// src/pages/GTC.js

import React from 'react';
import { useTranslation } from 'react-i18next';
import PageMeta from '../components/SEO/PageMeta';
import StructuredData from '../components/SEO/StructuredData';

const GTC = () => {
    const { t } = useTranslation();
    // useDocTitle hook is no longer needed

    const sections = t('gtc_page.sections', { returnObjects: true }) || [];
    const companyDetails = t('imprint_page', {returnObjects: true}) || [];

    const DetailItem = ({ label, value }) => (
        <div className="py-2">
            <dt className="font-bold text-gray-800">{label}</dt>
            <dd className="text-gray-600">{value}</dd>
        </div>
    );

    return (
        <>
            <PageMeta
                title={t('gtc_page.doc_title')}
                description={t('gtc_page.meta_description')}
                path="/gtc"
            />
            <StructuredData type="page" page={{ name: t('gtc_page.title'), path: '/gtc', description: t('gtc_page.meta_description') }} />

            <div className="bg-white py-12">
                <div className="max-w-4xl mx-auto py-16 sm:py-24 px-4">
                    <div className="text-left">
                        <h1 className="text-4xl font-extrabold text-gray-900 sm:text-5xl tracking-tight">
                            {t('gtc_page.title')}
                        </h1>
                        <p className="mt-6 text-xl text-gray-500 whitespace-pre-line text-justify">
                            {t('gtc_page.intro')}
                        </p>
                    </div>

                    <div className="mt-10 border-t border-gray-200 pt-8">
                        <h2 className="text-2xl font-bold text-gray-900">{t('gtc_page.company_details_title')}</h2>
                         <dl className="mt-4">
                            <DetailItem label={companyDetails.company_name_label} value={companyDetails.company_name_value} />
                            <DetailItem label={companyDetails.address_label} value={companyDetails.address_value} />
                            <DetailItem label={companyDetails.reg_number_label} value={companyDetails.reg_number_value} />
                            <DetailItem label={companyDetails.tax_number_label} value={t('footer.company_info.tax_number_value')} />
                            <DetailItem label={companyDetails.email_label} value={<a href={`mailto:${companyDetails.email_value}`} className="text-primary hover:underline">{companyDetails.email_value}</a>} />
                            <DetailItem label={companyDetails.hosting_provider_label} value={companyDetails.hosting_provider_value} />
                        </dl>
                    </div>

                    <div className="mt-10">
                        {Array.isArray(sections) && sections.map((section, index) => (
                            <div key={index} className="py-6">
                                <h3 className="text-2xl font-bold text-gray-900">{section.title}</h3>
                                <p className="mt-4 text-lg text-gray-600 whitespace-pre-line text-justify">
                                    {section.text}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default GTC;